import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type TrainingInvitationReminderProps = BaseNotificationItemProps & {
  type: 'training_invitation_reminder'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function TrainingInvitationReminder({ program, ...props }: TrainingInvitationReminderProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Training Invitation Reminder`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`You've been invited to begin training for ${program.displayName}. Get started to become eligible for work on this program.`}</p>
      }
    />
  )
}
